import { Col, Divider, Row } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const SectionWrapper = styled(Flex)`
  width: 100%;
`
export const OuterDiv = styled.div`
  border: 1px solid ${COLORS.PAGE_BORDER};
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  margin: 30px 100px 20px 100px;
  border-radius: 10px;
  @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    margin: 30px 20px 20px 20px;
  }
`

export const TopNav = styled(Flex)`
  height: 160px;
  background-color: #fafafb;
  padding: 30px;
  flex-direction: column;
`
export const TopNav1 = styled(Flex)`
  background-color: #fafafb;
  flex-direction: column;
`

export const SectionName = styled.div`
  margin-left: 20px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`

export const TitleMedium = styled.h2`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_700)};
  font-size: ${FONT.F_2XL};
  line-height: 30px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: 0;
`
export const SubtitleLarge = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  padding-left: 10px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: 5px;
`
export const GrayTextSmall = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 30px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
`

export const InfoText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_BASE)};
  line-height: 30px;
  color: ${COLORS.GREY_T_50_2};
  margin-bottom: 0;
  margin-left: ${props => (props.marginleft ? props.marginleft : '0px')};
  margin-right: ${props => (props.marginRight ? props.marginRight : '0px')};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '')};
  word-wrap: break-word;
`

export const YellowBox = styled(Flex)`
  padding: 10px;
  background: ${COLORS.ORANGE_T_92};
  border: 1px solid ${COLORS.ORANGE_T_60};
  border-radius: 10px;
  gap: 15px;
`

export const FlexWrap = styled(Flex)`
  position: relative;
  gap: ${props => (props.gap ? props.gap : '0px')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  padding: ${props => (props.padding ? props.padding : '0px')};
  background-color: ${props => (props.bgColor ? props.bgColor : 'transparent')};
`
export const GrayText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
  margin-bottom: 0;
`

export const SubtitleSmall = styled.p`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_400)};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_SM)};
  line-height: 20px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '5px')};
  span {
    font-style: normal;
    font-weight: ${FONT.FW_600};
    line-height: 18px;
    color: ${COLORS.GREY_T_10};
    margin-right: 5px;
  }
`

export const SubtitleMedium = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_10};
  margin-bottom: 0;
`

export const VerticalDivider = styled(Divider)`
  height: 20px;
`

export const VerticalDividerMax = styled(Divider)`
  height: 40px;
`

export const FlexContain = styled(Flex)`
  padding: 15px 0px;
`
export const FlexContain1 = styled(Flex)`
  padding: 0px 0px;
`
export const LeftCol = styled(Col)`
  padding: 10px;
`
export const Editor = styled.div`
  width: 85%;
  word-wrap: break-word;
`
export const Address = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
`
export const TextWithIcon = styled.div`
  display: flex;
  align-items: ${({ alignItems }) => (alignItems ? '' : 'center')};

  gap: ${({ gap }) => gap || '1rem'};
  width: ${({ width }) => width || ''};
  justify-content: ${({ justify }) => justify || 'start'};
  flex-direction: ${({ direction }) => direction || 'row'};
  flex-wrap: ${props => (props.wrap ? props.wrap : 'nowrap')};
`

export const SkillBox = styled.div`
  background: ${props => (props.isColor ? '#D6FFF2' : '#EBECEE')} !important;
  width: fit-content;
  padding: 3px 8px 3px 8px;
  border-radius: 6px;
  color: #010e30;
  font-size: 14px;
  font-weight: 500;
`
export const SkillBoxDiv = styled.div`
  background: #ebecee;
  width: Hug (211px) px;
  padding: 10px;
  border-radius: 10px;
  color: #010e30;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgb(223 224 227);
`
export const Condition = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #010e30;
  text-align: 'center';
`

export const NameAdd = styled(Flex)`
  gap: 3px;
  padding-left: 15px;
`
export const Container = styled(Flex)`
  padding-right: 20px;
`
export const Name = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #343e59;
`
export const BreadCrumns = styled.div`
  display: flex;
`
export const RowContainer = styled(Row)`
  padding: 20px;
`

export const EditorContent = styled.span`
  padding: 20px 0;
  * {
    line-height: 188%;
    color: #000000 !important;
  }
  p,
  ul,
  ol {
    margin-bottom: 10px;
  }

  li {
    line-height: 25px;
  }
`
export const PopHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
  padding-top: 15px;
  padding-bottom: 5px;
`

export const PopHeading1 = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
  padding-top: 15px;
  padding-bottom: 10px;
`

export const PopSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #808697;
  padding-top: 5px;
`
export const Name1 = styled.div`
  font-weight: 600;
  font-size: 16px;
  height: 24px;
  line-height: 22px;
  text-align: center;
  color: #343e59;
`
export const Address1 = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
`
export const AddressNew = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #1b1f22;
  opacity: 0.48;
`
export const Frame = styled.div`
  padding: 20px;
`
export const ShareTitile = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #343e59;
`
export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
`
export const RowListIcon = styled(Flex)`
  gap: 10px;
`
export const ColListIcon = styled(Flex)`
  gap: 10x;
  cursor: pointer;
`

export const RowListLabel = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #343e59;
`

export const DropRow = styled(Row)`
  width: 470px;
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 10px;
  outline: none;
  box-shadow: 0px 2px 10px rgb(99 116 135 / 20%);
`

export const CenteredDiv = styled.div`
  width: 100%;
  padding: 20px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #3d5a8080;
`

export const OneLinerDiv = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #808697;
  text-transform: capitalize;
`

export const SocialMeadiaIconsFlex = styled(Flex)`
  gap: 10px;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  padding-bottom: 18px;
`

export const PopSubHeadingLI = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #808697;
  padding-top: 5px;
  overflow-wrap: break-word;
  height: ${({ expanded }) => (expanded ? 'auto' : '200px')};
  overflow: hidden;
`

export const Stream = styled.div``

export const PopSubHeadingLIMore = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #808697;
  padding-top: 5px;
  overflow-wrap: break-word;

  overflow: hidden;
`

export const SubBold = styled.span`
  font-weight: bold;
  color: #343e59;
`

export const Container1 = styled.div`
  height: ${props => (props.expanded ? 'auto' : '250px')};

  overflow: hidden;
  overflow-wrap: break-word;
`

export const Content = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #808697;
`

export const ExtraPadding = styled.div`
  padding-bottom: 8px;
`

export const ShowMoreText = styled.span`
  cursor: pointer;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  color: #000;
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  border-radius: 10px;
  background-color: #e6e7ea;
`

export const SkillList = styled.ul`
  padding-inline-start: 20px;
  padding: 0px;
`

export const AndDivision = styled.div`
  font-size: 14px;
  font-weight: 500;
  width: 1000px;
  color: #010e30;
`

export const ShowDiv = styled.div`
  /* font-size: 15px;
 color: blue;
 text-align: left; */
  color: rgb(50, 73, 215);
  font-weight: bold;
  cursor: pointer;
`
export const SkillBoxRed = styled.div`
  display: flex;
  background: #ffe5e2;
  width: fit-content;
  padding: 3px 8px 3px 8px;
  border-radius: 6px;
  color: #010e30;
  font-size: 14px;
  font-weight: 500;
  align-items: center;

  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};

  span {
    padding-left: 5px;
    margin-bottom: -3px;
  }
`
